import React from 'react';
import Image from 'next/image'
import {Container, Typography} from "@mui/material";
import FeatureImage_1 from '../../../../../public/images/shop/top/feature_1.png'
import FeatureImage_2 from '../../../../../public/images/shop/top/feature_2.png'
import FeatureImage_3 from '../../../../../public/images/shop/top/feature_3.png'
import FeatureImage_4 from '../../../../../public/images/shop/top/feature_4.png'
import {Box} from "@material-ui/core";
import LinkButton from "../../../atoms/LinkButton";
import colorPalette from "../../../../styles/theme/colorPalette";
import ArrowRightIcon from "@material-ui/icons/ArrowRight";
import {ArrowDropDown} from "@material-ui/icons";
import {css} from "@emotion/react";
import DietitiansCarousel from "./DietitiansCarousel";

const Features = () => {
  return (
      <Container>
        <Box css={boxStyle}>
          <div>
            <Image src={FeatureImage_1}/>
          </div>
          <Typography css={{lineHeight: '1.7', margin: '1rem 0'}}>
            <span>
              電話オペレーターの100%が栄養士。悩んだ時、困った時、いつでもご相談いただけます。
            </span>
          </Typography>
          <DietitiansCarousel/>
          <div css={btnWrapper}>
            <LinkButton
                text={'ミールタイム栄養士一覧'}
                href={'/dietitians'}
                maxWidth={"300px"}
                hexColorCode={colorPalette.gray}
                endAdornment={ <ArrowRightIcon /> }
                css={btnStyle}
            />
            <LinkButton
                text={'ミールタイムが選ばれる理由'}
                href={'/#reason'}
                maxWidth={"300px"}
                hexColorCode={colorPalette.gray}
                endAdornment={ <ArrowDropDown /> }
                css={btnStyle}
            />
          </div>
        </Box>
        <Box css={boxStyle}>
          <div>
            <Image src={FeatureImage_2}/>
          </div>
          <Typography css={{lineHeight: '1.7', margin: '1rem 0'}}>
            <span>
              栄養士によるサポートと手軽な調理で食事療法を続けやすく、お客様からの検査結果の改善報告を多くいただいています。
            </span>
          </Typography>
          <div css={btnWrapper}>
            <LinkButton
                text={'数値改善ハッピーレポート'}
                href={'/#happy_report'}
                maxWidth={"300px"}
                hexColorCode={colorPalette.gray}
                endAdornment={ <ArrowDropDown /> }
                css={btnStyle}
            />
          </div>
        </Box>
        <Box css={boxStyle}>
          <div>
            <Image src={FeatureImage_3}/>
          </div>
          <Typography css={{lineHeight: '1.7', margin: '1rem 0'}}>
            <span>
              糖尿病食（ヘルシー食）、腎臓病食（たんぱく質調整食）、嚥下調整食（ケア食）など、各疾病に合わせた商品開発を栄養士・管理栄養士が行なっています。
            </span>
          </Typography>
          <div css={btnWrapper}>
            <LinkButton
                text={'商品一覧'}
                href={'/items'}
                maxWidth={"300px"}
                hexColorCode={colorPalette.gray}
                endAdornment={ <ArrowRightIcon /> }
                css={btnStyle}
            />
            <LinkButton
                text={'商品の特徴'}
                href={'/#item_features'}
                maxWidth={"300px"}
                hexColorCode={colorPalette.gray}
                endAdornment={ <ArrowDropDown /> }
                css={btnStyle}
            />
          </div>
        </Box>
        <Box css={boxStyle}>
          <div>
            <Image src={FeatureImage_4}/>
          </div>
          <Typography css={{lineHeight: '1.7', margin: '1rem 0'}}>
            <span>
              医療機関と連携した食事コントロールは、数値改善を実現するための基本です。制限数値に合わせたお食事をお届けします。
            </span>
          </Typography>
          <div css={btnWrapper}>
            <LinkButton
                text={'ミールタイムのここがいい！'}
                href={'/#partners'}
                maxWidth={"300px"}
                hexColorCode={colorPalette.gray}
                endAdornment={ <ArrowDropDown /> }
                css={btnStyle}
            />
          </div>
        </Box>
      </Container>
  );
};

export default Features;

const boxStyle = css`
  max-width: 460px;
  margin: 0 auto;
`

const btnWrapper = css`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-bottom: 40px;
`

const btnStyle = css`
  margin: 5px auto;
`